export default "__VITE_ASSET__43b621b7__"